import ContentPage, { ContentPageProps } from '../../src/entities/Content/ui/Content';
import { getHelpPage } from '@/common/service/api/HelpPages/HelpPages';
import { getRedirectsPath } from '@/common/service/api/Redirects/getRedirectsPath';
import { GetStaticProps } from 'next';

const revalidateList = ['promocodes'];
const PATHS = [
    'changes-and-cancellations',
    'customer-assistance',
    'customer-service-guide',
    'official-fishing-guide',
    'policy',
    'faq',
    'party-boat-fishing-guide',
    'policy#gdpr',
    'promocodes',
    'terms',
    'things-to-know-before-you-book',
    'vouchers-guide',
];

export async function getStaticPaths() {
    const paths = PATHS.map((path) => ({ params: { contentSlug: [path] } }));

    return {
        paths,
        fallback: 'blocking',
    };
}

type ContentSlugStaticProps = {
    contentSlug: string[];
};

export const getStaticProps: GetStaticProps<ContentPageProps, ContentSlugStaticProps> = async ({
    params,
}) => {
    try {
        if (!params) {
            throw new Error(`PAGE CONTENT: BAD PARAMS: ${params}`);
        }
        const infoSlug = params.contentSlug[0].toLowerCase() || '';

        if (infoSlug !== params.contentSlug[0] || params.contentSlug.length > 1) {
            const pathname = params.contentSlug.join('/')

            const isWrongCase = /[A-Z]/.test(pathname) && !pathname.includes('/accessForm');

            const redirectPath = await getRedirectsPath(`/${params.contentSlug.join('/')}/`);

            const isSMSLink = redirectPath.includes('/order/access/');
            const isWrongReviews = params.contentSlug[3] === 'reviews' && !!params.contentSlug[4];

            if(isSMSLink){
                return {
                    redirect: {
                        destination: redirectPath,
                        statusCode: 301,
                    },
                };
            }

            if(isWrongReviews){
                return {
                    redirect: {
                        destination: redirectPath.toLowerCase(),
                        statusCode: 301,
                    },
                };
            }

            if (isWrongCase) {
                return { redirect: {
                    destination: `/${pathname}/`.toLowerCase(),
                    statusCode: 301,
                }
            };
            }

            if (PATHS.includes(infoSlug)) {
                return {
                    redirect: {
                        destination: `/${infoSlug}/`,
                        statusCode: 301,
                    },
                };
            }

            if(redirectPath === '/404/'){
                return {
                    notFound: true,
                };
            }

            return {
                redirect: {
                    destination: redirectPath.toLowerCase(),
                    statusCode: 301,
                },
            };
        }

        const pageContent = await getHelpPage(infoSlug.toLowerCase());

        if (!pageContent) {
            const redirectPath = await getRedirectsPath(`/${params.contentSlug.join('/')}/`);

            if(redirectPath === '/404/'){
                return {
                    notFound: true,
                };
            }
            
            return {
                redirect: {
                    destination: redirectPath.toLowerCase(),
                    statusCode: 301,
                },
            };
        }

        return {
            revalidate: revalidateList.includes(infoSlug[0]) && Number(process.env.CACHE_ENV),
            props: {
                urlParam: infoSlug,
                pageContent,
            },
        };
    } catch (e) {
        throw new Error((e as Error).message);
    }
};

export default ContentPage;
